import React from 'react';
import PropTypes from 'prop-types';
import PortfolioImage from './PortfolioImage';

const SoundCloudIcon = () => (
  <svg
    className="pf-social-icon"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M23.999 14.165c-.052 1.796-1.612 3.169-3.4 3.169h-8.18a.68.68 0 0 1-.675-.683V7.862a.747.747 0 0 1 .452-.724s.75-.513 2.333-.513a5.364 5.364 0 0 1 2.763.755 5.433 5.433 0 0 1 2.57 3.54c.282-.08.574-.121.868-.12.884 0 1.73.358 2.347.992s.948 1.49.922 2.373ZM10.721 8.421c.247 2.98.427 5.697 0 8.672a.264.264 0 0 1-.53 0c-.395-2.946-.22-5.718 0-8.672a.264.264 0 0 1 .53 0ZM9.072 9.448c.285 2.659.37 4.986-.006 7.655a.277.277 0 0 1-.55 0c-.331-2.63-.256-5.02 0-7.655a.277.277 0 0 1 .556 0Zm-1.663-.257c.27 2.726.39 5.171 0 7.904a.266.266 0 0 1-.532 0c-.38-2.69-.257-5.21 0-7.904a.266.266 0 0 1 .532 0Zm-1.647.77a26.108 26.108 0 0 1-.008 7.147.272.272 0 0 1-.542 0 27.955 27.955 0 0 1 0-7.147.275.275 0 0 1 .55 0Zm-1.67 1.769c.421 1.865.228 3.5-.029 5.388a.257.257 0 0 1-.514 0c-.21-1.858-.398-3.549 0-5.389a.272.272 0 0 1 .543 0Zm-1.655-.273c.388 1.897.26 3.508-.01 5.412-.026.28-.514.283-.54 0-.244-1.878-.347-3.54-.01-5.412a.283.283 0 0 1 .56 0Zm-1.668.911c.4 1.268.257 2.292-.026 3.572a.257.257 0 0 1-.514 0c-.241-1.262-.354-2.312-.023-3.572a.283.283 0 0 1 .563 0Z" />
  </svg>
);

const RAIcon = () => (
  <svg
    className="pf-social-icon"
    viewBox="0 0 83 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M82.092 32.018c.556-.533.908-1.28.908-2.113 0-.802-.38-1.523-.9-2.051L58.665 4.3l-7.073 7.11 18.45 18.543h-26.14c-1.278-.038-2.29-.469-3.147-1.304l-11.73-11.788a6.828 6.828 0 00-4.689-1.888l-.017.001H10.004v-4.92h14.825c2.938.002 5.559 1.21 7.48 3.15l8.749 8.793 7.073-7.11-8.92-8.963C35.485 2.234 30.45 0 24.805 0H0v25.027h20.978v.002a4.919 4.919 0 013.486 1.48L35.95 38.053A6.74 6.74 0 0040.449 40h31.733a4.911 4.911 0 003.423-1.45l6.491-6.524-.004-.008"
      fill="currentColor"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg
    className="pf-social-icon"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077" />
  </svg>
);

const EmailIcon = () => (
  <svg
    className="pf-social-icon"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2-8 5-8-5h16zm0 12H4V8.236l8 5 8-5V18z"
      fill="currentColor"
    />
  </svg>
);

const PhoneIcon = () => (
  <svg
    className="pf-social-icon"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"
      fill="currentColor"
    />
  </svg>
);

const stop = (e) => e.stopPropagation();

// ── PropType shapes ───────────────────────────────────────────────────────────
const entryShape = PropTypes.shape({
  image: PropTypes.string,
  imgClass: PropTypes.string,
  artist: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  meta: PropTypes.string,
  caption: PropTypes.string,
});

const cvEntryShape = PropTypes.shape({
  role: PropTypes.string,
  org: PropTypes.string,
  date: PropTypes.string,
  tech: PropTypes.string,
  bullets: PropTypes.arrayOf(PropTypes.string),
});

const sectionShape = PropTypes.shape({
  heading: PropTypes.string,
  entries: PropTypes.arrayOf(cvEntryShape),
});

const gigShape = PropTypes.shape({
  date: PropTypes.string,
  event: PropTypes.string,
  venue: PropTypes.string,
});

const heroShape = PropTypes.shape({
  image: PropTypes.string,
  artist: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  meta: PropTypes.string,
});

const projectShape = PropTypes.shape({
  type: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  squareImages: PropTypes.bool,
  soundcloud: PropTypes.string,
  ra: PropTypes.string,
  instagram: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  supports: PropTypes.arrayOf(PropTypes.string),
  notableShows: PropTypes.arrayOf(PropTypes.string),
  heroImage: heroShape,
  leftColumn: PropTypes.arrayOf(entryShape),
  rightColumn: PropTypes.arrayOf(entryShape),
  sections: PropTypes.arrayOf(sectionShape),
  gigs: PropTypes.arrayOf(gigShape),
});

// ── Gallery item ──────────────────────────────────────────────────────────────
const GalleryItem = ({ entry, imgClass }) => {
  const cls = entry.imgClass || imgClass;
  return (
    <div className="pf-gallery-item">
      {entry.image ? (
        <PortfolioImage className={`pf-img ${cls}`} src={entry.image} alt={entry.artist || ''} />
      ) : (
        <div className={`pf-img pf-img--placeholder ${cls}`} />
      )}
      {entry.artist && <p className="pf-gallery-item__artist">{entry.artist}</p>}
      {(entry.title || entry.date) && (
        <p className="pf-gallery-item__title">
          {entry.title}
          {entry.date ? `, ${entry.date}` : ''}
        </p>
      )}
      {entry.meta && <p className="pf-gallery-item__meta">{entry.meta}</p>}
      {entry.caption && <p className="pf-gallery-item__caption">{entry.caption}</p>}
    </div>
  );
};

GalleryItem.propTypes = {
  entry: entryShape.isRequired,
  imgClass: PropTypes.string,
};

GalleryItem.defaultProps = {
  imgClass: '',
};

// ── Parse DD.MM.YY date strings for sorting ───────────────────────────────────
const parseDate = (str) => {
  if (!str) return 0;
  const [d, m, y] = str.split('.');
  return new Date(`20${y}-${m}-${d}`).getTime();
};

// ── Two-column gallery layout ─────────────────────────────────────────────────
const GalleryOverlay = ({ project, handleBgClick }) => {
  const leftClass = project.squareImages ? 'pf-img--square' : 'pf-img--tall';

  const sortedItems = [...(project.leftColumn || []), ...(project.rightColumn || [])].sort(
    (a, b) => parseDate(a.date) - parseDate(b.date)
  );

  return (
    <div
      className="pf-overlay__body"
      role="presentation"
      onClick={handleBgClick}
      onKeyDown={handleBgClick}
    >
      {/* Left panel */}
      {(project.heading || project.description) && (
        <div className="pf-overlay__text-panel" role="presentation" onClick={stop} onKeyDown={stop}>
          {project.heading && <h2 className="pf-overlay__heading">{project.heading}</h2>}
          {project.description &&
            project.description.split('\n\n').map((para) => (
              <p key={para.substring(0, 40)} className="pf-overlay__description">
                {para}
              </p>
            ))}
          {(project.supports || []).length > 0 && (
            <div className="pf-overlay__supports">
              <p className="pf-overlay__supports-label">notable supports</p>
              <ul className="pf-overlay__supports-list">
                {project.supports.map((name) => (
                  <li key={name}>{name}</li>
                ))}
              </ul>
            </div>
          )}
          {(project.notableShows || []).length > 0 && (
            <div className="pf-overlay__supports">
              <p className="pf-overlay__supports-label">notable shows</p>
              <ul className="pf-overlay__supports-list">
                {project.notableShows.map((show) => (
                  <li key={show}>{show}</li>
                ))}
              </ul>
            </div>
          )}
          {(project.soundcloud ||
            project.instagram ||
            project.ra ||
            project.email ||
            project.phone) && (
            <div className="pf-social-links">
              {project.email && (
                <a href={`mailto:${project.email}`} aria-label="Email">
                  <EmailIcon />
                </a>
              )}
              {project.phone && (
                <a href={`tel:${project.phone}`} aria-label="Phone">
                  <PhoneIcon />
                </a>
              )}
              {project.instagram && (
                <a
                  href={project.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <InstagramIcon />
                </a>
              )}
              {project.soundcloud && (
                <a
                  href={project.soundcloud}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="SoundCloud"
                >
                  <SoundCloudIcon />
                </a>
              )}
              {project.ra && (
                <a
                  href={project.ra}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Resident Advisor"
                >
                  <RAIcon />
                </a>
              )}
            </div>
          )}
        </div>
      )}

      {/* Right panel */}
      <div
        className="pf-overlay__images"
        role="presentation"
        onClick={handleBgClick}
        onKeyDown={handleBgClick}
      >
        {/* Hero image */}
        {project.heroImage && (
          <div className="pf-overlay__hero" role="presentation" onClick={stop} onKeyDown={stop}>
            <PortfolioImage
              className="pf-img pf-img--hero"
              src={project.heroImage.image}
              alt={project.heroImage.artist || ''}
              loading="eager"
            />
            {project.heroImage.artist && (
              <p className="pf-gallery-item__artist">{project.heroImage.artist}</p>
            )}
            {(project.heroImage.title || project.heroImage.date) && (
              <p className="pf-gallery-item__title">
                {project.heroImage.title}
                {project.heroImage.date ? `, ${project.heroImage.date}` : ''}
              </p>
            )}
            {project.heroImage.meta && (
              <p className="pf-gallery-item__meta">{project.heroImage.meta}</p>
            )}
          </div>
        )}

        {/* Image columns */}
        {((project.leftColumn || []).length > 0 || (project.rightColumn || []).length > 0) && (
          <div className="pf-overlay__cols" role="presentation" onClick={stop} onKeyDown={stop}>
            <div className="pf-overlay__col-left pf-desktop-only">
              {(project.leftColumn || []).map((entry) => (
                <GalleryItem key={entry.image || entry.date} entry={entry} imgClass={leftClass} />
              ))}
            </div>
            <div className="pf-overlay__col-right pf-desktop-only">
              {(project.rightColumn || []).map((entry) => (
                <GalleryItem
                  key={entry.image || entry.date}
                  entry={entry}
                  imgClass="pf-img--square"
                />
              ))}
            </div>
            <div className="pf-overlay__col-mobile">
              {sortedItems.map((entry) => (
                <GalleryItem key={entry.image || entry.date} entry={entry} imgClass={leftClass} />
              ))}
            </div>
          </div>
        )}

        {/* Sections (CV-style content) */}
        {(project.sections || []).length > 0 && (
          <div className="pf-cv pf-cv--left" role="presentation" onClick={stop} onKeyDown={stop}>
            {project.sections.map((section) => (
              <div key={section.heading} className="pf-cv__section">
                <p className="pf-cv__heading">{section.heading}</p>
                {section.entries.map((entry) => (
                  <div key={entry.role} className="pf-cv__entry pf-cv__entry--left">
                    <p className="pf-cv__role">
                      {entry.role}
                      {entry.date ? (
                        <span className="pf-cv__date--inline"> · {entry.date}</span>
                      ) : (
                        ''
                      )}
                    </p>
                    {entry.org && <p className="pf-cv__org">{entry.org}</p>}
                    {entry.tech && <p className="pf-cv__tech">{entry.tech}</p>}
                    {(entry.bullets || []).length > 0 && (
                      <ul className="pf-cv__bullets">
                        {entry.bullets.map((b) => (
                          <li key={b.substring(0, 40)}>{b}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        {/* Gigs list */}
        {(project.gigs || []).length > 0 && (
          <div role="presentation" onClick={stop} onKeyDown={stop}>
            <h3 className="pf-gigs__title">Gig Archive</h3>
            <ul className="pf-gigs">
              {(project.gigs || []).map((gig) => (
                <li key={`${gig.date}-${gig.event}`} className="pf-gigs__item">
                  <span className="pf-gigs__date">{gig.date}</span>
                  <span className="pf-gigs__event">{gig.event}</span>
                  <span className="pf-gigs__venue">{gig.venue}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

GalleryOverlay.propTypes = {
  project: projectShape.isRequired,
  handleBgClick: PropTypes.func,
};

GalleryOverlay.defaultProps = {
  handleBgClick: undefined,
};

// ── CV layout ─────────────────────────────────────────────────────────────────
const CVOverlay = ({ project, handleBgClick }) => (
  <div className="pf-cv-wrap" role="presentation" onClick={handleBgClick} onKeyDown={handleBgClick}>
    <div className="pf-cv" role="presentation" onClick={stop} onKeyDown={stop}>
      {(project.sections || []).map((section) => (
        <div key={section.heading} className="pf-cv__section">
          <p className="pf-cv__heading">{section.heading}</p>
          {section.entries.map((entry) => (
            <div key={entry.role} className="pf-cv__entry">
              <p className="pf-cv__role">{entry.role}</p>
              {entry.org && <p className="pf-cv__org">{entry.org}</p>}
              {entry.date && <p className="pf-cv__date">{entry.date}</p>}
              {entry.tech && <p className="pf-cv__tech">{entry.tech}</p>}
              {(entry.bullets || []).length > 0 && (
                <ul className="pf-cv__bullets">
                  {entry.bullets.map((b) => (
                    <li key={b.substring(0, 40)}>{b}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

CVOverlay.propTypes = {
  project: projectShape.isRequired,
  handleBgClick: PropTypes.func,
};

CVOverlay.defaultProps = {
  handleBgClick: undefined,
};

// ── Root component ────────────────────────────────────────────────────────────
const ProjectOverlay = ({ project, visible, onClose }) => {
  const handleBgClick = visible ? onClose : undefined;
  const type = project?.type;

  return (
    <div className={`pf-overlay${visible ? ' pf-overlay--visible' : ''}`}>
      {type === 'gallery' && <GalleryOverlay project={project} handleBgClick={handleBgClick} />}
      {type === 'cv' && <CVOverlay project={project} handleBgClick={handleBgClick} />}
      {(!type || type === 'about') && (
        <div
          className="pf-overlay__images"
          role="presentation"
          onClick={handleBgClick}
          onKeyDown={handleBgClick}
        />
      )}
    </div>
  );
};

ProjectOverlay.propTypes = {
  project: projectShape,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

ProjectOverlay.defaultProps = {
  project: null,
  visible: false,
  onClose: undefined,
};

export default ProjectOverlay;
